export default __webpack_public_path__ + "static/media/td-ameritrade.ad477053.jpg";